module.exports = __webpack_public_path__ + "static/img/SketchPnged2131b1729d0d270266b2120ecc43ab530cee0b31dff14946762f7014b1d78e.63938327.png";